import { Deserializable } from '../deserializable';

export class Tag implements Deserializable {
  id: number;
  userId: number;
  name: string;
  colour: string;
  active: boolean;
  dateTimeUpdated: Date;

  recentlyUpdated: boolean = false;

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}

export namespace Tag {
  export enum Id {
    AIT_REACHED = 1,
    AGGRESSIVE_TRADER = 2,
    OWN_AIT = 3,
    CHECK_NOTES = 5,
    SHARING = 6,
    HIGHER_ARB = 7,
    HIGH_RISK = 10,
    AIT_NOTES = 11,
    WITHDRAWAL = 13,
    TRADE_FOR_SARS = 14,
    DEPOSIT_DETECTED = 15,
    PRIORITIZE = 16,
    BAD_CFS_STATUS = 19,
    ODD_NEEDED = 20,
  }
}
